import './devbx.webform.popup.window.css';

BX.addCustomEvent("DevBxWebFormCreated", function(app) {
    app.component('devbx-webform-popup-window', {
        props: {
            contentCenter: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                elOverlay: false,
                eventKeyup: false,
            };
        },
        mounted() {
            this.elOverlay = document.createElement('div');
            this.elOverlay.classList.add('devbx-webform-popup-overlay');
            this.elOverlay.setAttribute('style', 'z-index: 1050 !important');
            this.elOverlay.addEventListener('click', BX.delegate(this.overlayClick, this));

            document.body.appendChild(this.elOverlay);
            document.body.appendChild(this.$el);

            this.eventKeyup = BX.delegate(this.keyUp, this);
            document.addEventListener('keyup', this.eventKeyup);
        },
        beforeUnmount() {
            this.elOverlay.remove();
            document.removeEventListener('keyup', this.eventKeyup);
        },
        methods: {
            overlayClick()
            {
                this.$emit('close');
            },

            popupWindowClick(event)
            {
                if (event.target == this.$el)
                    this.$emit('close');
            },

            keyUp(event)
            {
                if (event.keyCode == 27)
                    this.$emit('close');
            }
        },
        template: `
        <div class="devbx-webform-theme devbx-webform-popup-window" style="z-index: 1055 !important;" @click="popupWindowClick($event)">
            <div class="devbx-webform-popup-container">
                <div class="devbx-webform-popup-close" @click.stop.prevent="$emit('close')"></div>
                <div class="devbx-webform-popup-content" :class="{'devbx-webform-popup-content-center': contentCenter}">
                    <slot></slot>
                </div>
                <div class="devbx-webform-popup-buttons">
                    <div class="devbx-webform-popup-button devbx-webform-popup-button-primary" @click.stop.prevent="$emit('close')">
                        <span>{{$Bitrix.Loc.getMessage('DEVBX_WEB_FORM_BTN_CLOSE_TITLE')}}</span>
                    </div>                
                </div>
            </div>
        </div>
        `
    });
});